<template>
  <div class="columns is-centered">
    <div class="column is-8">
      <div class="box">
        <div
          v-if="profile.id"
          class="section"
        >
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Account Created
              </h2>
              <div class="subtitle is-2">
                You have successfully created your account.
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="column">
                <p>Hello <b>{{ profile.firstName }} {{ profile.lastName }}</b>, an account confirmation e-mail was sent to <b>{{ profile.emailAddress }}</b>. Please open the e-mail and click on the link to confirm your account. You will not be able to login until your account has been confirmed.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'UserRegistered',
  components: {},
  mixins: [],
  props: {
    profile: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  async created () {
    if (!this.profile.id) {
      this.$router.push({ name: 'login' });
    }
  },
};
</script>
